/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Component, forwardRef, Input } from '@angular/core';
import {
	AbstractControl,
	ControlValueAccessor,
	FormBuilder,
	FormControl,
	FormGroup,
	NG_VALIDATORS,
	NG_VALUE_ACCESSOR,
} from '@angular/forms';

const customValueProvider = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => ColourPickerComponent),
	multi: true,
};
const customValidateProvider = {
	provide: NG_VALIDATORS,
	useExisting: forwardRef(() => ColourPickerComponent),
	multi: true,
};

@Component({
	selector: 'colour-picker',
	template:
		'<div [formGroup]="dataForm"><input formControlName="colour" matInput type="color" [tabIndex]="startTabIndex" style="cursor: pointer;"/></div>',
	providers: [customValueProvider, customValidateProvider],
	standalone: false,
})
export class ColourPickerComponent implements ControlValueAccessor {
	dataForm: FormGroup;
	@Input() startTabIndex = 1;

	writtenValue: string;

	constructor(fb: FormBuilder) {
		this.dataForm = fb.group({
			colour: [],
		});

		this.dataForm.valueChanges.subscribe(() => this.onFormChanged());
	}

	get colour(): AbstractControl {
		return this.dataForm.controls['colour'];
	}

	// required to propogate the changes to the consuming form
	onFormChanged() {
		this.propagateChange(this.colour.value);
		this.onTouched();
	}

	propagateChange: any = () => {};
	onTouched: any = () => {
		console.log('touched');
	};

	writeValue(colour: string): void {
		this.writtenValue = colour;
		this.setControlsFromWrittenValue();
	}

	private setControlsFromWrittenValue() {
		this.colour.setValue(this.writtenValue);
	}

	registerOnChange(fn: any): void {
		this.propagateChange = fn;
	}

	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	public validate(c: FormControl) {
		return null;
	}
}
